/* eslint-disable no-lone-blocks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";

const FootprintInputCheckbox = ({ onClick = () => {}, data }) => {
  const [items, setItems] = useState();
  useEffect(() => {
    setItems(data);
  }, []);

  if (data && Array.isArray(data)) {
    return (
      <div className="d-flex flex-wrap">
        {data.map((item, i) => {
          {
          }
          return (
            <div className="ml-4" key={i}>
              {" "}
              <Input
                key={i}
                type="checkbox"
                id={"exampleCustomInline" + i}
                label={item.label}
                className=""
                onChange={(e) => {
                  const alteredItems = items.map((myItem) => ({
                    ...myItem,
                    checked:
                      myItem.value.key === item.value.key
                        ? !myItem.checked
                        : myItem.checked,
                  }));
                  setItems(alteredItems);

                  if (onClick) {
                    onClick(alteredItems);
                  }
                }}
                inline
              />
              {item.label} &nbsp;
            </div>
          );
        })}
      </div>
    );
  } else {
    return <div />;
  }
};

export default FootprintInputCheckbox;
